module.exports = __webpack_public_path__ + "img/menu.5b8fbe76.svg";